"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UserBalance = function (_a) {
    var _b, _c, _d;
    var _e = _a.buttonColor, buttonColor = _e === void 0 ? 'gradient' : _e;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var pendingWithdrawals = (0, swr_hooks_1.usePendingWithdrawals)().data;
    var pendingBalance = (0, swr_hooks_1.usePendingDeposits)().data;
    var _f = (0, swr_hooks_1.useBalance)(), balance = _f.data, isLoading = _f.isLoading;
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var router = (0, navigation_1.useRouter)();
    var _g = (0, react_1.useState)(false), mounted = _g[0], setMounted = _g[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var openWithdrawal = function () {
        return router.push(generateUrlWithLang("/account/wallet/withdrawal"));
    };
    var openBonusesCash = function () {
        return router.push(generateUrlWithLang("/account/bonuses/cash"));
    };
    var openBonusesFS = function () {
        return router.push(generateUrlWithLang("/account/bonuses/freespins"));
    };
    var freespins = (0, swr_hooks_1.useFreespinsCards)().freespins;
    // const activeFreespins = useMemo(() => {
    //   return freespins.find(bonus => bonus.status === FreeRoundStatus.InProgress)
    // }, [freespins])
    var totalFreespins = (0, react_1.useMemo)(function () {
        return freespins.filter(function (bonus) {
            return bonus.status === profile_api_1.FreeRoundStatus.Active ||
                bonus.status === profile_api_1.FreeRoundStatus.InProgress ||
                bonus.status === profile_api_1.FreeRoundStatus.Pending;
        });
    }, [freespins]);
    var totalFreespinsAmount = (0, react_1.useMemo)(function () {
        if (!totalFreespins.length)
            return 0;
        return totalFreespins.reduce(function (acc, cur) { return acc + Number(cur.amount); }, 0);
    }, [totalFreespins]);
    if (!mounted)
        return null;
    if (!isAuth && !isLoading) {
        closeModal();
    }
    if (isLoading || !balance) {
        return (react_1.default.createElement(ui_components_1.Modal, { width: "340px", padding: "16px", saveSize: true },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.loadingContainer },
                react_1.default.createElement(ui_components_1.LoadingSpinner, null))));
    }
    return (react_1.default.createElement(ui_components_1.Modal, { width: "340px", padding: "20px", saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('balance')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.balance }, balance
            ? "".concat((0, apps_shared_1.getCurrencySymbol)(balance === null || balance === void 0 ? void 0 : balance.currency), " ").concat((_b = Number(balance === null || balance === void 0 ? void 0 : balance.totalAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2))
            : ''),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
            balance && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('realBalance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, "".concat((0, apps_shared_1.getCurrencySymbol)(balance.currency), " ").concat((_c = Number(balance.amount)) === null || _c === void 0 ? void 0 : _c.toFixed(2))))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
            balance && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row, onClick: openBonusesCash },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('bonusBalance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, "".concat((0, apps_shared_1.getCurrencySymbol)(balance.currency), " ").concat((_d = ((Number(balance.totalAmount) || 0) -
                    (Number(balance.amount) || 0))) === null || _d === void 0 ? void 0 : _d.toFixed(2)),
                    react_1.default.createElement(image_1.default, { src: "/img/icons/arrow.svg", alt: "arrow", width: "12", height: "12" })))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row, onClick: openBonusesFS },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('freespins')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value },
                    totalFreespinsAmount,
                    react_1.default.createElement(image_1.default, { src: "/img/icons/arrow.svg", alt: "arrow", width: "12", height: "12" }))),
            pendingBalance && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.row, " ").concat(styles_module_scss_1.default.pendingWithdrawals) },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('pendingBalance')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, pendingBalance)))),
            pendingWithdrawals && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.row, " ").concat(styles_module_scss_1.default.pendingWithdrawals) },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('pendingWithdrawals')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, pendingWithdrawals))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { maxWidth: "100%", onClick: openDeposit, color: buttonColor, text: "upper" }, t('deposit'))),
        react_1.default.createElement("div", { onClick: openWithdrawal, className: styles_module_scss_1.default.withdrawal }, t('withdrawal'))));
};
exports.default = UserBalance;
